import { type EffortLevel } from "../../shared/aiProviders";

// Bars in a 16×16 box: 2px wide, 2px gaps, centered, heights ramping to full so
// the tallest bar is always the top *available* level. Deriving the layout from
// the count means a model without `max` shows three centered bars (high = full
// height) rather than a clipped four-bar glyph. Four bars reproduces
// services/ui/assets/icons/effort.svg exactly. Inlined rather than rendered
// through the mask-based Icon so individual bars can animate between levels.
function layoutBars(count: number) {
  const startX = 9 - 2 * count;
  return Array.from({ length: count }, (_, i) => {
    const height = Math.round((12 * (i + 1)) / count);
    return { x: startX + i * 4, y: 14 - height, height };
  });
}

export function EffortIcon({
  level,
  levels,
}: {
  level: EffortLevel;
  levels: readonly EffortLevel[];
}) {
  const size = 16;
  const active = Math.max(1, levels.indexOf(level) + 1);
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" aria-hidden>
      {layoutBars(levels.length).map((bar, i) => (
        <rect
          key={bar.x}
          x={bar.x}
          y={bar.y}
          width={2}
          height={bar.height}
          rx={1}
          fill="currentColor"
          style={{
            transformBox: "fill-box",
            transformOrigin: "bottom",
            transform: i < active ? "scaleY(1)" : "scaleY(0.4)",
            opacity: i < active ? 1 : 0.3,
            transition: "transform 180ms ease, opacity 180ms ease",
          }}
        />
      ))}
    </svg>
  );
}
